import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

interface PrimaryMaterialModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
  formik: any;
}

const PrimaryMaterialModal = (props: PrimaryMaterialModalProps & { isButtonDisabled: boolean }) => {
  const { isOpen, onClose, formik, isButtonDisabled } = props;

  return (
    <>
      <Dialog open={isOpen} onClose={onClose} fullWidth>
        <DialogActions>
          <Button onClick={onClose}>x</Button>
        </DialogActions>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              name="name"
              label={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : "Enter Primary Material"
              }
              type="text"
              fullWidth
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && formik.errors.name}
              onBlur={formik.handleBlur}
            />
            <TextField
              margin="dense"
              id="leagoCode"
              name="leagoCode"
              label={
                formik.touched.leagoCode && formik.errors.leagoCode
                  ? formik.errors.leagoCode
                  : "Enter LEAGO Code"
              }
              type="text"
              fullWidth
              value={formik.values.leagoCode ?? ""}
              onChange={formik.handleChange}
              error={formik.touched.leagoCode && formik.errors.leagoCode}
              onBlur={formik.handleBlur}
            />
            <TextField
                margin="dense"
                id="pimKey"
                name="pimKey"
                label={
                    formik.touched.pimKey && formik.errors.pimKey
                    ? formik.errors.pimKey
                    : "Enter PIM Key"
                }
                type="text"
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.pimKey}
                error={formik.touched.pimKey && formik.errors.pimKey}
            />
            <h4>Set Active</h4>
            <RadioGroup
              row
              name="isActive"
              value={formik.values.isActive}
              onChange={(event) => formik.handleChange(event)}
            >
              <FormControlLabel
                value={true}
                control={<Radio />}
                label="Active"
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label="Inactive"
              />
            </RadioGroup>
            <DialogActions>
              <Button variant="contained" type="submit" disabled={isButtonDisabled}>
                {formik.values.id > 0
                  ? "Update Primary Material"
                  : "Add Primary Material"}
              </Button>
            </DialogActions>
          </DialogContent>
        </form>
      </Dialog>
    </>
  );
};

export default PrimaryMaterialModal;
